import React from 'react';

const CardIcon = () => {
  return (
    <svg width="106" height="92" viewBox="0 0 106 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <rect x="4" y="9.57184" width="79" height="76" rx="6" transform="rotate(-5.5 4 9.57184)" fill="white" />
        <rect
          x="3.72719"
          y="9.34695"
          width="79.5"
          height="76.5"
          rx="6.25"
          transform="rotate(-5.5 3.72719 9.34695)"
          stroke="#E6E9EC"
          strokeWidth="0.5"
        />
      </g>
      <rect x="18.842" y="59.3785" width="48" height="4" transform="rotate(-5.5 18.842 59.3785)" fill="#E6E9EC" />
      <rect x="19.7046" y="68.3372" width="16" height="4" transform="rotate(-5.5 19.7046 68.3372)" fill="#E6E9EC" />
      <rect
        x="14.7207"
        y="16.5765"
        width="20"
        height="20"
        rx="10"
        transform="rotate(-5.5 14.7207 16.5765)"
        fill="#C1C3C6"
      />
      <path
        d="M22.6151 25.5278L25.4931 27.5948L28.7595 23.2618"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g>
        <rect x="22" y="6" width="79" height="76" rx="6" fill="white" />
        <rect x="21.75" y="5.75" width="79.5" height="76.5" rx="6.25" stroke="#E6E9EC" strokeWidth="0.5" />
      </g>
      <rect x="32" y="57" width="48" height="4" fill="#787F88" />
      <rect x="32" y="66" width="16" height="4" fill="#E6E9EC" />
      <circle cx="42.5" cy="24.5" r="11.5" fill="#F5F6F7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.674 28.0445C41.9671 28.6403 41.0502 29 40.0482 29C37.8124 29 36 27.2091 36 25C36 22.7909 37.8124 21 40.0482 21C41.0502 21 41.9671 21.3597 42.674 21.9555C43.3809 21.3597 44.2979 21 45.2998 21C47.5356 21 49.348 22.7909 49.348 25C49.348 27.2091 47.5356 29 45.2998 29C44.2979 29 43.3809 28.6403 42.674 28.0445Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.6741 28.0445C43.5445 27.3108 44.0964 26.2191 44.0964 25C44.0964 23.7809 43.5445 22.6892 42.6741 21.9555C43.381 21.3597 44.2979 21 45.2999 21C47.5356 21 49.3481 22.7909 49.3481 25C49.3481 27.2091 47.5356 29 45.2999 29C44.2979 29 43.381 28.6403 42.6741 28.0445Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.674 28.0444C43.5444 27.3108 44.0963 26.2191 44.0963 25C44.0963 23.7809 43.5444 22.6892 42.674 21.9556C41.8036 22.6892 41.2517 23.7809 41.2517 25C41.2517 26.2191 41.8036 27.3108 42.674 28.0444Z"
        fill="#FF5E00"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0.046875"
          y="0.0469971"
          width="93.8266"
          height="91.1279"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_d"
          x="17.5"
          y="3.5"
          width="88"
          height="85"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default CardIcon;
